// import {Module} from "vuex";
// import {RootStoreState} from "@/store/RootStoreState";
// import {HttpHandler} from "@/http/HttpHandler";
// import router from "@/router";
// import {QuestionnaireResult} from "@/entities/questionaire/QuestionnaireResult";
// import store from "@/store/index";

// interface QuestionnaireState {
//     questionnaireResult: QuestionnaireResult;
// }

// const questionnaireModule: Module<QuestionnaireState, RootStoreState> = {
//     namespaced: true,
//     state: {
//         questionnaireResult: new QuestionnaireResult([], []),
//     },
//     getters: {},
//     mutations: {
//         setQuestionnaireResult(state: QuestionnaireState, result: QuestionnaireResult) {
//             state.questionnaireResult = result;
//         },
//     },
//     actions: {
//         async submitQuestionnaireResults({commit}, {branchId, questionnaireResults, safetyFirst}) {
//             const httpHandler = new HttpHandler(store);
//             const result: QuestionnaireResult = await httpHandler.postQuizResultObjectsByBranchId(branchId, questionnaireResults, false, safetyFirst);
//             commit('setQuestionnaireResult', result);

//             await router.push({name: 'Questionnaire result'});
//         },
//     }
// };

// export default questionnaireModule;


import {Module} from "vuex";
import {RootStoreState} from "@/store/RootStoreState";
import {HttpHandler} from "@/http/HttpHandler";
import router from "@/router";
import {QuestionnaireResult} from "@/entities/questionaire/QuestionnaireResult";
import store from "@/store/index";

interface QuestionnaireState {
    questionnaireResult: QuestionnaireResult;
    identifier: string | null; // Add identifier to state
}

const questionnaireModule: Module<QuestionnaireState, RootStoreState> = {
    namespaced: true,
    state: {
        questionnaireResult: new QuestionnaireResult([], []),
        identifier: null, // Add identifier to state
    },
    getters: {
        getQuestionnaireIdentifier: (state: QuestionnaireState) => state.identifier // Add getter
    },
    mutations: {
        setQuestionnaireResult(state: QuestionnaireState, result: QuestionnaireResult) {
            state.questionnaireResult = result;
        },
        
        // Add identifier mutations
        SET_QUESTIONNAIRE_IDENTIFIER(state: QuestionnaireState, identifier: string) {
            state.identifier = identifier;
            console.log('Questionnaire identifier set in store:', identifier);
        },
        
        CLEAR_QUESTIONNAIRE_IDENTIFIER(state: QuestionnaireState) {
            console.log('Clearing questionnaire identifier from store:', state.identifier);
            state.identifier = null;
        }
    },
    actions: {
        async submitQuestionnaireResults({commit}, {branchId, questionnaireResults, safetyFirst}) {
            const httpHandler = new HttpHandler(store);
            const result: QuestionnaireResult = await httpHandler.postQuizResultObjectsByBranchId(branchId, questionnaireResults, false, safetyFirst);
            commit('setQuestionnaireResult', result);

            await router.push({name: 'Questionnaire result'});
        },
        
        // Add identifier actions (optional, you can use mutations directly)
        setIdentifier({commit}, identifier: string) {
            commit('SET_QUESTIONNAIRE_IDENTIFIER', identifier);
        },
        
        clearIdentifier({commit}) {
            commit('CLEAR_QUESTIONNAIRE_IDENTIFIER');
        }
    }
};

export default questionnaireModule;